import { Box, Header, SpaceBetween, Table } from '@cloudscape-design/components';

import { SDKDocSearchResult } from '../../../../common/types/interfaces';

interface ISDKDocComponentsProps {
  sdkDocItem: SDKDocSearchResult;
}

export function SDKDocResultHeader({ sdkDocItem }: ISDKDocComponentsProps) {
  return <Header description={sdkDocItem.content.handler?.functionHandler}>{sdkDocItem.content.capabilityName}</Header>;
}

export function SDKInputArgs({ sdkDocItem }: ISDKDocComponentsProps) {
  if (sdkDocItem.content.input?.params && sdkDocItem.content.input.params.length > 0) {
    return (
      <SpaceBetween size="s">
        <Box fontSize="heading-xs" variant="awsui-key-label">
          Input parameters
        </Box>
        <Table
          variant="embedded"
          items={sdkDocItem.content.input.params}
          columnDefinitions={[
            { id: 'paramName', header: 'Name', cell: (item) => item.name },
            {
              id: 'type',
              header: 'Type',
              cell: (item) => (
                <Box variant="code" display="inline">
                  {item.type}
                </Box>
              ),
            },
            { id: 'description', header: 'Description', cell: (item) => item.description || '' },
          ]}
        />
      </SpaceBetween>
    );
  } else {
    return <SDKDocElement header="Input Parameters" value="None" />;
  }
}

export function SDKDocElement(props: { header: string; value: string }) {
  return (
    <>
      <Box fontSize="heading-xs" variant="awsui-key-label">
        {props.header}
      </Box>
      <pre className="tw-word-wrap tw-ma0">
        <Box variant="p">{props.value}</Box>
      </pre>
    </>
  );
}

export function SDKOutput({ sdkDocItem }: ISDKDocComponentsProps) {
  if (sdkDocItem.content.output && Object.keys(sdkDocItem.content.output).length > 0) {
    return (
      <SpaceBetween size="s">
        <Box fontSize="heading-xs" variant="awsui-key-label">
          Output
        </Box>
        <Table
          variant="embedded"
          items={[sdkDocItem.content.output]}
          columnDefinitions={[
            {
              id: 'type',
              header: 'Type',
              cell: (item) => (
                <Box variant="code" display="inline">
                  {item.type}
                </Box>
              ),
            },
            { id: 'description', header: 'Description', cell: (item) => item.description || '' },
          ]}
        />
      </SpaceBetween>
    );
  } else {
    return <SDKDocElement header="Output" value="None" />;
  }
}

export function SDKInstance({ sdkDocItem }: ISDKDocComponentsProps) {
  if (sdkDocItem.content.input?.instance && Object.keys(sdkDocItem.content.input.instance).length > 0) {
    return (
      <SpaceBetween size="s">
        <Box fontSize="heading-xs" variant="awsui-key-label">
          Instance
        </Box>
        <Table
          variant="embedded"
          items={[sdkDocItem.content.input.instance]}
          columnDefinitions={[
            {
              id: 'type',
              header: 'Type',
              cell: (item) => (
                <Box variant="code" display="inline">
                  {item.type}
                </Box>
              ),
            },
            {
              id: 'value',
              header: 'Value',
              cell: (item) => (
                <Box variant="code" display="inline">
                  {item.value}
                </Box>
              ),
            },
          ]}
        />
      </SpaceBetween>
    );
  } else {
    return <SDKDocElement header="Instance" value="None" />;
  }
}

/* TODO: Add back SDKExample component when documentation of Blocks have been published
export function SDKExample({ sdkDocItem }: ISDKDocComponentsProps) {
  if (!sdkDocItem.example) {
    return null;
  }
  return (
    <>
      <Box fontSize="heading-xs" variant="awsui-key-label">
        Example
      </Box>
      <div className="tw-flex">
        <Box variant="code" className="tw-flex-grow tw-mr2">
          <Textarea className="tw-font-inherit" value={sdkDocItem.example} rows={5} />
        </Box>
        <CopyText
          copyText={sdkDocItem.example}
          errorText="Error while copying"
          successText="Example copied"
          hideCopyContent={true}
          copyButtonLabel="Copy example"
          buttonVariant="normal"
        />
      </div>
    </>
  );
} */
